<template>
  <div id="users-list" class="users-list-container">
    <user-view-sidebar-edit :isSidebarActive="editDataSideBar" @closeSidebar="toggleDataSidebar"
      :user='currentUserEdit' />
    <user-view-sidebar-add :isSidebarActive="addDataSideBar" @closeSidebar="toggleAddDataSidebar"
      :user='currentUserEdit' />
    <vs-table ref="table" multiple noDataText="Sem dados disponíveis" v-model="selected" pagination
      :max-items="itemsPerPage" search :data="users">
      <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
        <div class="flex flex-wrap-reverse items-center">
          <!-- ADD NEW -->
          <div class="
                p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-between
                text-lg font-medium text-base text-primary border border-solid border-primary
              " @click="addDataSideBar = true"
                v-if="canSee('add')">
            <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
            <span class="ml-2 text-base text-primary">Adicionar Novo</span>
          </div>
        </div>


        <!-- ITEMS PER PAGE -->
        <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4">
          <div class="
                p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg
                cursor-pointer flex items-center justify-between font-medium
              ">
            <span class="mr-2">
              {{ currentPage * itemsPerPage - (itemsPerPage - 1) }} -
              {{
                users.length - currentPage * itemsPerPage > 0
                ? currentPage * itemsPerPage
                : users.length
              }} of {{ queriedItems }}
            </span>
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div>
          <vs-dropdown-menu>
            <vs-dropdown-item @click="itemsPerPage = 4">
              <span>4</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage = 10">
              <span>10</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage = 15">
              <span>15</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage = 20">
              <span>20</span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
      </div>

      <template slot="thead">
        <vs-th sort-key="name">Nome</vs-th>
        <vs-th sort-key="email">Email</vs-th>
        <vs-th sort-key="actions" v-if="canSee('update') || canSee('remove')">Ações</vs-th>
      </template>

      <template slot-scope="{data}">
        <tbody>
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td>
              <p class="product-name font-medium truncate">{{ tr.name }}</p>
            </vs-td>

            <vs-td>
              <p class="product-name font-medium truncate">{{ tr.email }}</p>
            </vs-td>

            <vs-td class="whitespace-no-wrap">
              <feather-icon v-if="canSee('update')" icon="EditIcon" svgClasses="w-5 h-5 hover:text-primary stroke-current"
                @click.stop="editDataSideBar = true, currentUserEdit = { 'id': tr.id, 'name': tr.name, 'email': tr.email, 'role': tr.role.display_name, 'website_ids': tr.website_ids }" />

              <feather-icon v-if="canSee('remove')" icon="TrashIcon" svgClasses="w-5 h-5 hover:text-danger stroke-current" class="ml-2"
                @click.stop="removeUserModal(tr)" />

                <feather-icon
                v-if="(canSee('unblock') || isAdminUser) && tr.blocked_at" icon="LockIcon" svgClasses="w-5 h-5 hover:text-danger stroke-current" class="ml-2"
                @click.stop="unblockUserModal(tr)"
              />
            </vs-td>
          </vs-tr>
        </tbody>
      </template>
    </vs-table>

    <vs-popup
      title="Você realmente deseja fazer isso?"
      :active.sync="popupActivatedUnblock"
    >
      <p>
        Você deseja realmente desbloquear o usuário {{ userInfos.email }}?
      </p>

      <vs-button
        color="rgb(62, 201, 214)"
        type="filled"
        class="align-right"
        @click.prevent="unblockUser(userInfos.id)"
      >
        <span>Sim</span>
      </vs-button>
    </vs-popup>

    <vs-popup title="Você realmente deseja fazer isso?" :active.sync="removePopupActivated">
      <p>
        Você deseja realmente remover o usuário {{ userInfos.email }}?
      </p>

      <vs-button color="rgb(62, 201, 214)" type="filled" class="align-right"
        @click.prevent="removeUser(userInfos.id), removePopupActivated = false">
        <span>Sim</span>
      </vs-button>
    </vs-popup>

    <vs-popup title="Alteraração do usuario:" :active.sync="alterPopupActivated">
      <p>
        Você irá alterar o usuario {{ userInfos.name }}
      </p>

      <vs-button color="rgb(62, 201, 214)" type="filled" class="align-right"
        @click.prevent="removeUser(userInfos.id), removePopupActivated = false">
        <span>Sim</span>
      </vs-button>
    </vs-popup>

  </div>
</template>

<script>
import UserViewSidebarEdit from './UserViewSidebarEdit.vue'
import UserViewSidebarAdd from './UserViewSidebarAdd.vue'

import user from '@/http/requests/user'
import { mapGetters } from 'vuex'
import Button from '../../components/button/Button.vue'
import { hasPermissionBackOffice } from './../../utils/index';

export default {
  name: 'users-list',
  components: {
    UserViewSidebarEdit,
    UserViewSidebarAdd,
    Button
  },
  data() {
    return {
      selected: [],
      popupActivated: false,
      removePopupActivated: false,
      alterPopupActivated: false,
      itemsPerPage: 5,
      isMounted: false,
      editDataSideBar: false,
      sidebarData: {},
      userInfos: {},
      sidebarActive: false,
      currentUserEdit: {},
      addDataSideBar: false,
      popupActivatedUnblock: false,
    }
  },
  computed: {
    ...mapGetters([
      'token',
      'name',
      'email',
      'users',
      'hasLogged'
    ]),
    isAdminUser() {
      let userInfo = JSON.parse(localStorage.getItem("userInfo"))
      if (userInfo && userInfo.role) {
        if (userInfo.role.name === 'administrador') {
          return true
        }
      }

      return false
    },
    currentPage() {
      if (this.isMounted) {
        return this.$refs.table.currentx
      }

      return 0
    },

    queriedItems() {
      return this.$refs.table ? this.$refs.table.queriedResults.length : this.users.length
    }
  },
  methods: {
    closePopupUsers(){
      this.alterPopupActivated = false;
      this.removePopupActivated = false;
      this.popupActivatedUnblock = false;
      this.addDataSideBar = false;
      this.editDataSideBar = false;
    },
    verify(){
      const permissions = localStorage.getItem('permissions');
      const twoFactor = localStorage.getItem('twoFactor')
      if(!permissions && !twoFactor){
          this.$router.push('/user-settings')
      }else if(!permissions && twoFactor){
          this.$router.push('/two-factor')
      }
    },
    async getUsers() {
      try {
        await this.$store.dispatch('getAllUsers')
      } catch (Exception) {
        return []
      }
    },
    removeUserModal(userInfos) {
      this.userInfos = userInfos
      this.removePopupActivated = true
    },
    unblockUserModal(userInfos){
        this.userInfos = userInfos
        this.popupActivatedUnblock = true
      },
      async unblockUser(id) {
      try {
        this.$vs.loading()
        await this.$store.dispatch('alterUserUnblock', {id: id, token: this.token, alterObject: {attempts: null, blocked_at: null}});
        await this.getUsers();

        this.$vs.notify({
          color: 'success',
          title: 'Sucesso!',
          text: 'Usuário desbloqueado com sucesso.',
        });
        this.popupActivatedUnblock = false

        this.$vs.loading.close();
        return true;
      } catch (Exception) {
        this.$vs.notify({
          title: 'Erro ao desbloquear:',
          text: 'Entre em contato conosco',
          color: 'danger',
        });
        this.popupActivatedUnblock = false

        this.$vs.loading.close();
        return false;
      }
    },
    logoutUser() {
      user.disconnectUser(this.userInfos.id).then(() => {
        this.$store.dispatch("user/fetch")
      })
      this.userInfos = {};
      this.popupActivated = false
    },
    async removeUser(id) {
      try {
        this.$vs.loading()
        await this.$store.dispatch('deleteUser', { id: id, token: this.token })
        await this.getUsers();
        this.$vs.notify(
          {
            title: 'Deleção feita com sucesso:',
            text: 'Sucesso!!',
            color: 'success'
          }
        )
        this.$vs.loading.close()
        return true;
      } catch (Exception) {
        this.$vs.notify(
          {
            title: 'Erro na deleção:',
            text: 'Entre em contato conosco',
            color: 'danger'
          }
        )
        this.$vs.loading.close()
        return false;
      }
    },
    editData(data) {
      this.userInfos = data
      this.alterPopupActivated = true
    },
    toggleDataSidebar(val = false) {
      this.editDataSideBar = val;
    },
    toggleAddDataSidebar(val = false) {
      if (!val) {
        this.currentUserEdit = {
          id: null,
          name: '',
          username: '',
          email: '',
          password: '',
          role: ''
        };
      }
      this.addDataSideBar = val;
    },
    canSee(word) {
      return hasPermissionBackOffice(`${this.$route.name}-${word}`);
    }
  },
  mounted() {
    this.isMounted = true;
    this.getUsers();
    this.verify();
  },
  beforeRouteLeave(to, from, next) {
    this.closePopupUsers()
    setTimeout( ()=> {
      next();
    }, 10);
  },
}
</script>

<style lang="scss">
#users-list {
  .vs-con-table {

    .product-name {
      max-width: 23rem;
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap-reverse;
      margin-left: 1.5rem;
      margin-right: 1.5rem;

      >span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          &+i {
            left: 1rem;
          }

          &:focus+i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;


      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, .05);

        td {
          padding: 10px;

          &:first-child {
            border-top-left-radius: .5rem;
            border-bottom-left-radius: .5rem;
          }

          &:last-child {
            border-top-right-radius: .5rem;
            border-bottom-right-radius: .5rem;
          }

          &.img-container {
            // width: 1rem;
            // background: #fff;

            span {
              display: flex;
              justify-content: flex-start;
            }

            .product-img {
              height: 110px;
            }
          }
        }

        td.td-check {
          padding: 20px !important;
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
        }
      }

      th.td-check {
        padding: 0 15px !important;
      }

      tr {
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
</style>
